import { defineStore } from "pinia";
import type { RendererElement } from "vue";

export type LayoutRegion = "header" | "banner" | "userMenu";
export type LayoutRegionValue = string | RendererElement | undefined | Element | ComponentPublicInstance | null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type LayoutRegionBinds = Record<string, any>;

export type LayoutRegionState = Record<
  LayoutRegion,
  {
    content: LayoutRegionValue;
    binds: LayoutRegionBinds;
  }
>;

export const useLayoutRegionStore = defineStore("layoutRegion", () => {
  const regions = reactive<Partial<LayoutRegionState>>({});

  const setRegion = (region: LayoutRegion, content: LayoutRegionValue, binds: LayoutRegionBinds = {}) => {
    regions[region] = { content, binds };
  };

  const getRegion = (region: LayoutRegion) => {
    return regions[region];
  };

  return { regions, setRegion, getRegion };
});
